module.exports = __webpack_public_path__ + "img/project_9.c2dcb2ae.png";